import { Box, Checkbox, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Modal, Radio, RadioGroup, Snackbar, Tooltip, Typography } from "@mui/material";
import Sidebar from "./Sidebar";
import { useEffect, useState } from "react";
import { Cancel, Check, Clear, Facebook, FacebookOutlined, Female, Instagram, Male, NotAccessible, Wc, X } from "@mui/icons-material";
import { useSalon } from "./context/SalonContext";
import axios from "axios";

export default function BusinessDetails() {

    const tabs = ['Business Info', 'Social Links', 'Business Provisions'];

    const [selectedTab, setSelectedTab] = useState(0);


    const instagramRegex = /^(https?:\/\/)?(www\.)?instagram\.com\/[A-Za-z0-9._-]+\/?$/i;
    const facebookRegex = /^(https?:\/\/)?(www\.)?facebook\.com\/[A-Za-z0-9._-]+\/?$/i;
    const xRegex = /^(https?:\/\/)?(www\.)?(x|twitter)\.com\/[A-Za-z0-9._-]+\/?$/i;

    const regexes = {
        instagram: instagramRegex,
        facebook: facebookRegex,
        x: xRegex
    }

    const { salon, setsalon } = useSalon();
    const [amentities, setamentities] = useState([]);

    const [shopData, setShopData] = useState([]);
    async function fetchDetails() {
        const id = localStorage.getItem('uuid');
        const result = await axios.post(databaseUrl + 'getShop', {
            Id: id,
        });
        var data = result.data;


        if (data?.reponse == 'failed') {
            alert(data.reason);
        } else {
            console.log('success')
            setShopData(data);
            setsalon(data);
            setmodal(false);
            setModalData(null);
            setamentities(data?.Amentities)
            console.log('dataFetched', data)
        }
    }


    useEffect(() => {
        if (!salon) {
            fetchDetails();
        } else {
            console.log("salonDetails", salon)
            setamentities(salon?.Amentities);
        }
    }, [salon])

    const [modal, setmodal] = useState(false);
    const [modalData, setModalData] = useState(null);
    const [url, seturl] = useState(null);


    var databaseUrl = `http://localhost:${process.env?.PORT || 3000}/`
    async function changeSocialLinks() {
        const result = await axios.post(databaseUrl + 'salon/details/links/save', {
            platformName: modalData.Platform,
            url,
            salonId: salon._id
        });
        var data = result.data;
        if (data.response == 'failed') {
            alert(data.reason);
        } else {
            console.log('successfully changed link.');
            fetchDetails();
        }
    }

    // useEffect(() => {
    //     fetchDetails();
    // },[salon])

    const [fetched, setFetched] = useState(false);

    async function SaveProvisions() {
        const result = await axios.post(databaseUrl + 'salon/details/provisions/edit', {
            Id: salon._id,
            Amentities: amentities
        });
        var data = result.data;
        if (data.response == 'success') {
            setEdit(false);
            setFetched(true);
            fetchDetails();
        } else {
            alert(data.reason);
        }
    }

    const [edit, setEdit] = useState(false);

    // useEffect(() => {
    //     console.log("Amentities",amentities);
    // }, [amentities])

    return (
        <>


            <Grid container height={'100vh'} className='admin-Section' width={'100%'}>
                <Sidebar />
                <Grid height={'100%'} p={3} container alignItems={'center'} justifyContent={'space-evenly'} flex={1}>

                    <Grid overflow={'hidden'} className='bg-blue text-white' borderRadius={1} size={{ lg: 3.5 }}>
                        <Typography variant="h6" className="p-3 text-center">Business Details</Typography>
                        {/* <hr className="text-white line"></hr> */}
                        {/* <Divider /> */}
                        {tabs.map((row, index) => (
                            <>
                                <Divider />
                                <Grid onClick={() => setSelectedTab(index)} key={row} className={selectedTab == index ? "business_details_listItem_active" : 'business_details_listItem'}>{row}</Grid>
                            </>
                        ))}
                        {/* <button className="business_details_listItem">Social Links</button> */}
                    </Grid>
                    <Grid size={{ lg: 7 }}>
                        <Grid container justifyContent={'space-between'} alignItems={'baseline'}>
                            <Typography variant="h4">
                                {tabs[selectedTab]}
                            </Typography>
                            <button onClick={() => setEdit(true)} className="button-outline-blue">
                                <Typography variant="body1" lineHeight={1}>Edit</Typography>
                            </button>
                        </Grid>
                        <Grid className='bg-blue text-white' borderRadius={1} p={3} mt={'.5rem'}>
                            {selectedTab == 0 ? (
                                <Grid container justifyContent={'between'}>
                                    <Grid size={{ lg: 5.5 }}>
                                        <Typography variant="h6" fontWeight={500}>Business name</Typography>
                                        <Typography variant="body1" className="">{salon?.Name}</Typography>
                                    </Grid>
                                    <Grid size={{ lg: 6 }}>
                                        <Typography variant="h6" fontWeight={500}>Location</Typography>
                                        <Typography variant="body1" className="">{salon?.Address}</Typography>
                                    </Grid>
                                    <Grid size={{ lg: 12 }} mt={2}>
                                        <Typography variant="h6" fontWeight={500}>description</Typography>
                                        <Typography variant="body1" className="">Abcd</Typography>
                                    </Grid>
                                </Grid>

                            ) : selectedTab == 1 ? (
                                <Grid container>
                                    {salon?.SocialLinks.map((row, index) => (
                                        <Grid className={index == (salon.SocialLinks.length - 1) && 'mt-2'} size={{ lg: 5.5 }}>
                                            {/* <Grid container justifyContent={'between'}> */}
                                            {/* <Grid className='w-100'> */}
                                            {/* <Grid container justifyContent={}> */}
                                            {/* <Grid className='d-flex align-items-center'> */}

                                            <Grid container alignItems={'center'}>
                                                <Typography variant="h6" fontWeight={500}>{row.Platform}
                                                </Typography>
                                                <Facebook className="ms-2" />
                                            </Grid>
                                            {/* </Grid> */}
                                            {row.Url == '' ? (
                                                <button onClick={() => {
                                                    setmodal(true)
                                                    setModalData(row)
                                                }} className="btn-outline-white p-1 px-3 mt-2 text-center">
                                                    <Typography variant="body1" className="">Add</Typography>
                                                </button>

                                            ) : (
                                                <Typography variant="h6" className="text-secondary">{row.Url}</Typography>
                                            )}
                                        </Grid>
                                    ))}
                                    <Modal open={modal} onClose={() => setmodal(false)}>

                                        <Box className='modall'>
                                            <div className="input-group">
                                                <input type="text" onChange={(e) => seturl(e.target.value)} className="form-control col-lg-10" />
                                                <button onClick={() => changeSocialLinks()} disabled={!regexes[modalData?.Platform.toLowerCase()]?.test(url)} className="btn-blue">Save</button>
                                            </div>
                                            {!regexes[modalData?.Platform.toLowerCase()]?.test(url) ? (
                                                <Typography className="mt-2" variant="body1">please enter a valid {modalData?.Platform.toLowerCase()} url.</Typography>
                                            ) : (
                                                <Typography className="mt-2" variant="body1">Click save to proceed</Typography>
                                            )}
                                        </Box>
                                    </Modal>
                                </Grid>
                            ) : (
                                <Grid container alignItems={'flex-start'} justifyContent={'space-between'}>
                                    {/* <form onSubmit={}> */}
                                    <Grid size={{ lg: 6.5 }}>
                                        <Typography variant="h6" className="d-flex align-items-center w-100"><span className="fw-bold me-2">Gender:</span> Male <Male color="primary" /></Typography>
                                        {/* <Typography variant="h6" fontWeight={'bold'} className="mt-2">About Salon:</Typography>
                                        <Typography className="mt-2" variant="body1">Qui excepteur aliquip id aute aute in ea laboris. Culpa consequat consectetur mollit labore incididunt excepteur laborum in anim non tempor dolor enim. Et adipisicing velit magna non mollit reprehenderit aliquip consectetur adipisicing qui esse proident enim. Velit Lorem tempor veniam exercitation consequat.</Typography> */}
                                    </Grid>
                                    <Grid size={{ lg: 4.5 }} container>
                                        <Typography variant="h6" className="d-flex align-items-center w-100 fw-bold">Amenities:</Typography>
                                        {salon?.Amentities.map((row) => (
                                            <div className="w-100 d-flex align-items-center justify-content-between mt-2">
                                                <Typography lineHeight={1} variant="body1">{row.Name}
                                                </Typography>
                                                {row.Availability ? (
                                                    <Check color="success" />
                                                ) : (
                                                    <Clear color="error" />
                                                )}
                                                {/* <Checkbox color={row.Avialability ? 'success' : 'error'} checkedIcon={
                                                    <Check />
                                                } icon={
                                                    <Clear />
                                                } sx={{ borderColor: 'white', padding: 0 }} /> */}
                                            </div>
                                        ))}
                                    </Grid>
                                    {/* <div className="form-check mt-2">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios1" value="male" />
                                            <label className="form-check-label" for="#exampleRadios1">
                                                Male
                                            </label>
                                        </div>
                                        <div className="form-check mt-2">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios2" value="female" />
                                            <label className="form-check-label" for="#exampleRadios2">
                                                Female
                                            </label>
                                        </div>
                                        <div className="form-check mt-2">
                                            <input className="form-check-input" type="radio" name="exampleRadios" id="exampleRadios3" value="both" />
                                            <label className="form-check-label" for="#exampleRadios3">
                                                Both
                                            </label>
                                        </div> */}
                                    {/* </form> */}
                                </Grid>
                            )}
                            <Modal open={edit} onClose={() => setEdit(false)}>
                                <Box className='modall'>
                                    <Grid container justifyContent={'space-between'} className=''>
                                        <Typography variant="h6" fontWeight={'bold'}>Gender:</Typography>
                                        <Tooltip title='Male'>
                                            <IconButton color="primary">
                                                <Male />
                                            </IconButton>
                                        </Tooltip>
                                        <IconButton title="Female" color="error">
                                            <Female />
                                        </IconButton>
                                        <IconButton title="Female" color="secondary">
                                            <Wc />
                                        </IconButton>
                                    </Grid>
                                    <Typography variant="h6" className='mt-2' fontWeight={'bold'}>Provisions:</Typography>
                                    {amentities.map((row) => (
                                        <div className="w-100 d-flex align-items-center justify-content-between mt-2">
                                            <Typography lineHeight={1} variant="body1">{row.Name}
                                            </Typography>
                                            {/* {row.Avialability ? (
                                                    <Check color="success" />
                                                    ) : (
                                                        <Clear color="error" />
                                                        )} */}
                                            <Checkbox defaultChecked={row.Availability} onChange={(e) =>
                                                setamentities(prev =>
                                                    prev.map(item =>
                                                        item.Name === row.Name
                                                            ? {
                                                                ...item,
                                                                Availability: e.target.checked
                                                            }
                                                            : item
                                                    )
                                                )
                                            } checkedIcon={
                                                <Check color="success" />
                                            } icon={
                                                <Clear color="error" />
                                            } sx={{ borderColor: 'white', padding: 0 }} />
                                        </div>
                                    ))}
                                    <button onClick={() => SaveProvisions()} disabled={JSON.stringify(salon?.Amentities) === JSON.stringify(amentities)} className="button-outline-blue w-100 mt-3">Save</button>
                                </Box>
                            </Modal>
                            <Snackbar onClose={() => setFetched(false)} autoHideDuration={4000} open={fetched} message='details saved' />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )

}